module.exports = __webpack_public_path__ + "img/message.bfbd4565.svg";